import React from 'react';

import aboutUs from 'assets/about_us.svg';

import { Container, AboutText } from './styles';

const About: React.FC = () => {
  return (
    <Container>
      <img src={aboutUs} alt="Sobre nós" />
      <AboutText>
        <h2>Quem Somos</h2>
        <p>
          Olá! Nós somos o time Circle. Nossa missão é auxiliar, através da
          tecnologia, diversos bairros e logradouros do Rio de Janeiro a
          compartilharem recomendações e serviços. Estamos coordenando com o
          grupo Somos JO Classificados para lançar um serviço que mira ajudar o
          comércio local do bairro.
        </p>
        <br />
        <p>
          David Maisonnette Jentjens é um programador de ponta, que aprendeu a
          programar quando ainda tinha 16 anos, vive se envolvendo em projetos e
          sempre vai além para tornar tecnologias fáceis de usar.
        </p>
        <br />
        <p>
          Caio Tranjan Lopes é estudante de economia da UFRJ, sonha em
          empreender e deixar sua marca no mundo.
        </p>
        <br />
        <p>
          Sinta-se livre para nos contatar com quaisquer questões! Somos
          amigáveis e sempre abertos para discutir novos projetos, ideias
          interessantes ou projetos de inovação.
        </p>
        <p className="quotename">- Caio e David</p>
      </AboutText>
    </Container>
  );
};

export default About;
